import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import MyAccountChild from "./MyAccountChild";
import { useLocation } from "react-router-dom";

const MyAccount = () => {
  const data = useLocation();
  const userRecord = data.state;
  return (
    <MainTemplate>
      <CardBackground>
        <MyAccountChild userRecord={userRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default MyAccount;
